import React, {Component} from 'react';
import { ServiceCollectionParam } from "../comp/ServiceCollection";
import ReviewQuestion from "./ReviewQuestion";
import { ReviewQuestionModel } from "./ReviewQuestionModel";
import { Link } from 'react-router-dom';
import MessageBox from "../comp/MessageBox";
import MessageProvider from "../classes/MessageProvider";
import { ReviewDbDto, ReviewQuestionAnswerDbDto } from "../common/dto/ReviewDbDto";

type Props = { reviewId: string }
type State = { questions: ReviewQuestionModel[], review: ReviewDbDto | undefined }

class ReviewForm extends Component<ServiceCollectionParam & Props, State> {

    messages = new MessageProvider(this.setState.bind(this));

    state: State = {
        questions: [],
        review: undefined
    }

    async componentDidMount() {

        let review = await this.props.services.dao.findReview(this.props.reviewId);
        if (!review) {
            throw Error('no review');
        }

        this.state.review = review;

        let questions = await this.props.services.dao
            .findReviewQuestions(this.state.review.tag);

        this.state.questions = questions.map(q =>
            new ReviewQuestionModel(q, this.isPassed(q.id, review)));

        this.setState(this.state);
    }

    private isPassed(questionId: string, review: ReviewDbDto) : boolean | undefined {
        if (!review.answers) {
            return undefined;
        }

        const entry = review.answers.find(a => a.questionId === questionId);

        if (entry === undefined) {
            return undefined;
        }

        return entry.answer;
    }

    render() {
        const isSubmitDisabled = this.state.review?.submittedDate
            && !this.props.services.uiSettings.isAdmin;

        return (
            <>
                <MessageBox messages={ this.messages.getMessages() } />

                Ülevaadatav kood asub <Link to={ '/review-files/' + this.props.reviewId}>siin</Link>.
                <br /><br />

            { this.state.questions.map(question =>
                <ReviewQuestion
                    notifyFunc={ () => this.setState(this.state) }
                    key={ question.question.id } model={ question } />) }

            <div>
                Kui vastate, et koodis on viga, siis peate lisama ka<br />
                kommentaari konkreetse rea juurde, kus see probleem asub.<br />
                Kommentaari saate lisada koodirea numbrile klikates.<br />
                Siin lehel olevate küsimustega seotud vead märkige tüübiga "Viga"<br />
                ja muud vead või kommentaarid tüübiga "Kommentaar".<br />
            </div>

            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                <button className="btn btn-danger"
                        disabled={ isSubmitDisabled }
                        onClick={ () => this.submit() }
                        type="button">Kinnita ja esita</button>
            </div>
            </>);
    }

    private async submit() {
        if (!this.state.review) {
            throw Error('no review');
        }

        this.messages.clearMessages();

        let someUnAnswered = this.state.questions
            .find(each => each.passed === undefined) !== undefined;

        if (someUnAnswered) {
            this.messages.error('Kõik küsimused pole vastatud.')
            return;
        }

        let comments = await this.props.services.dao
            .findReviewFileComments(this.props.reviewId);

        let failedQuestionIds = this.state.questions
            .filter(each => each.passed === false)
            .map(each => each.question.id);

        this.state.review.reviewPassed = this.state.questions.map(e => e.passed)
            .reduce((prev, current) => prev && current, true);

        this.state.review.answers = this.state.questions
            .map(e => new ReviewQuestionAnswerDbDto(e.question.id, e.passed));

        const message = `Probleemide kohta pole ühtegi kommentaari. 
                         Kommentaari lisamiseks klikige koodi juures olevale reanumbrile.`;

        if (failedQuestionIds.length !== 0 && comments.length === 0) {
            this.messages.error(message)
            return;
        }

        await this.props.services.dao.saveReview(this.state.review);

        this.props.services.history.goBack();
    }
}

export default ReviewForm